import React from 'react';
import { Breadcrumb } from 'antd';

import { dayFormatType, formatDay } from 'common/helpers/day';

export default function Header({ orderInfo = {}, t, history = () => {} }) {
  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="header">
      <Breadcrumb>
        <Breadcrumb.Item className="breadcrumb-link" onClick={handleGoBack}>
          Reconciliation List
        </Breadcrumb.Item>
        <Breadcrumb.Item>{`${orderInfo?.order?.student?.passportFirstName} ${
          orderInfo?.order?.student?.passportMiddleName ?? ''
        } ${orderInfo?.order?.student?.passportLastName}’s Booking`}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="title-wrapper">
        <span className="title-left">{`${orderInfo?.order?.referenceId} - ${
          orderInfo?.order?.student?.passportFirstName
        } ${orderInfo?.order?.student?.passportMiddleName ?? ''} ${
          orderInfo?.order?.student?.passportLastName
        }`}</span>
      </div>
      <div className="header-content__wrapper">
        <div className="header-content__left">
          <div className="form">
            <span className="label">Booking created date: </span>
            <span className="value">
              {orderInfo?.order?.createdAt
                ? formatDay(dayFormatType.UKFORMAT, orderInfo?.order?.createdAt)
                : '-'}
            </span>
          </div>
          <div className="form">
            <span className="label">Booking complete date: </span>
            <span className="value">
              {orderInfo?.order?.paidAt
                ? formatDay(dayFormatType.UKFORMAT, orderInfo?.order?.paidAt)
                : '-'}
            </span>
          </div>
          <div className="form">
            <span className="label">Currency: </span>
            <span className="value">{orderInfo?.currency ?? '-'}</span>
          </div>
        </div>
        <div className="header-content__right">
          <p className="title">Current Reconciliation Status</p>
          <p className="status">
            {orderInfo?.status
              ? t(`landlord.reconciliation_list.table.status.${orderInfo?.status?.toLowerCase()}`)
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
}
